/* eslint-disable @typescript-eslint/no-explicit-any */
import Client from "../shared/services/Client";

interface StripeCreditCardData {
    brand: string;
    lastFourDigits: string;
    expirationMonth: number;
    expirationYear: number;
}

export default {
    addCustomerToStripe(
        token: string,
        email: string,
        grecaptchaToken?: string | null,
        stripeApiTrackingName?: string,
        skipGrecaptcha = ""): Promise<any> {
        return Client.post(`/api/v3/payments/create-customer?skipGrecaptcha=${ skipGrecaptcha }`, {
            token,
            email,
            grecaptchaToken,
            stripeApiTrackingName
        });
    },

    getCustomerFromStripe(email: string): Promise<any> {
        return Client.post("/api/v3/payments/get-customer", {
            email
        });
    },

    addCardMetadataToStripe(cardId: string, customerId: string, cardBillingInfo: {postalCode?: string}): Promise<any> {
        return Client.post("/api/v3/payments/add-card-metadata", {
            cardId,
            customerId,
            cardBillingInfo
        });
    },

    addPreAuthCharge(cardId: string, customerId: string, ratePlanId: string, numberOfUsers: number): Promise<any> {
        return Client.post("/api/v3/payments/add-pre-auth-charge", {
            cardId,
            customerId,
            ratePlanId,
            numberOfUsers
        });
    },

    getCardFromStripe(creditCard: StripeCreditCardData): Promise<any> {
        return Client.post("/api/v3/payments/get-card", {
            creditCard
        });
    }
};
